import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from 'lib/queryClient'

interface OnboardingQueryProviderProps {
  children: React.ReactNode
}

/**
 * Wrapper component to provide React Query context
 * Use this to wrap components that need access to React Query
 */
export const SnugAppQueryProvider = ({
  children,
}: OnboardingQueryProviderProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* Show React Query DevTools in development */}
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  )
}
